import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "header"

export const schema = (required) =>
  Validation
    .string(required ? "admin.components.card.header.validation.string" : null)

const Header = ({benefit, onChange, required, ...props}) => {
  return (
    <StyledInput
      name={PROPERTY}
      value={benefit[PROPERTY]}
      onChange={(value) => onChange(PROPERTY, value)}
      onBlur={(value) => onChange(PROPERTY, value ? value.trim() : null)}
      validation={schema(required)}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

Header.propTypes = {
  benefit: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  maxLength: PropTypes.number
}

Header.defaultProps = {
  required: true,
  placeholder: "admin.components.card.header.input.placeholder",
  label: "admin.components.card.header.input.label",
  id: "benefit",
  maxLength: 44
}

export default Header
